import { Link, NavLink, useLocation } from 'react-router-dom'

import React, { useEffect, useState } from 'react'
import { RoutesEnum } from '../../core/enums'
import { fetchUserDetails } from '../../core/store/user/userSlice'
import { useAppDispatch, useAppSelector } from '../../hooks/useReduxToolkit'
import axiosIct from '../../utils/axios'

import './Sidebar.scss'

const ADMIN = [
  {
    label: 'Overview',
    href: '/'
  }
]

const CLIENTS = [
  {
    label: 'Dashboard',
    href: '/'
  },
  {
    label: 'Opportunities',
    href: RoutesEnum.Opportunities
  },
  {
    label: 'Support',
    href: RoutesEnum.Support
  },
  {
    label: 'Documents',
    href: RoutesEnum.FileManager
  }
]

const CLIENTS1 = [
  {
    label: 'Opportunities',
    href: RoutesEnum.Opportunities
  },
  {
    label: 'Support',
    href: RoutesEnum.Support
  },
  {
    label: 'Documents',
    href: RoutesEnum.FileManager
  }
]

export default function Sidebar (): React.ReactElement {
  const isHomePage = window.location.pathname === '/'
  const isSettingPage = window.location.pathname === RoutesEnum.Settings
  const location = useLocation()
  const clientId = new URLSearchParams(location.search).get('Client')
  const clientParam = clientId !== null ? `?Client=${clientId}` : ''
  const isAdmin = useAppSelector(s => s.user.user.isAdmin)
  const dispatch = useAppDispatch()
  const [clientName, setClientName] = useState<string>('')

  useEffect(() => {
    const doAsync = async (): Promise<void> => {
      await dispatch(fetchUserDetails())
      // setLoading(false)
    }
    void doAsync()
  }, [])

  useEffect(() => { 
  const fetchClient  = async (): Promise<void> => {
    try {
      if (clientId != '' && clientId != null) {
      const response = await axiosIct.get(`/clients/${clientId}`)
      setClientName(response.data.company_name)
      }
    } catch (error) {
      console.error('Error fetching client details:', error)
    } finally {
    }
  }
  void fetchClient()
  },[clientId])
    
  return (
    <div className='Sidebar'>
      {/* <div className='logo-wrap'>
        <Link to='/'>
          <Logo />
        </Link>
      </div> */}

      <div className="categories-container d-flex flex-column align-items-stretch ">
        <div className="category">
          {isAdmin && clientId !== null &&
          <>
          <p className="category-heading">ADMIN</p>
          {clientName && <p className='category-heading'>{clientName}</p>}
          </>
          }
          <ul className="links-container">
            {
              isAdmin
                ? (
                    ( isHomePage || isSettingPage) && clientId === null
                      ? (ADMIN.map((i, index) => {
                          return (<li key={index} >
                            <NavLink to={i.href} className='text-decoration-none links'>
                              {i.label}
                            </NavLink>
                          </li>)
                        }))
                      : (
                        CLIENTS.map((i, index) => {
                          return (<li key={index} >
                                <NavLink to={i.label === 'Dashboard' ? i.href : i.href + clientParam} className='text-decoration-none links'>
                                  {i.label}
                                </NavLink>
                          </li>)
                        }))
                  )
                : (CLIENTS1.map((i, index) => {
                    return (<li key={index} >
                      <NavLink to={i.href + clientParam} className='text-decoration-none links'>
                        {i.label}
                      </NavLink>
                    </li>)
                  })
                  )
          }
          </ul>
        </div>
      </div>
    </div>
  )
}
